import { Pipe, PipeTransform } from '@angular/core';
import * as dataUtils from './dataUtils';

@Pipe({
    name: 'dateFormat',
    pure: true
})

export class DateFormatPipe implements PipeTransform {
    transform(value: string, format: string = 'YYYY-MM-DD'): string {
        if (!value) {
            return null;
        }

        return dataUtils.formatDate(value, format);
    }
};
